
import {Component, Vue} from 'vue-property-decorator'
import { GoodsCategoryListDto, addGoodsCategory } from '@/api/commodity'
import { Form } from 'vant'

@Component
export default class GoodsCategoryForm extends Vue {
  visible = false
  parentCategoryLevel = 0
  parantObj: GoodsCategoryListDto
  form = {
    categoryName: '', // 分类名称
    categoryId: '' // 分类ID
  }

  showModal (level: number, categoryObj?: GoodsCategoryListDto) {
    this.visible = true
    this.resetData()
    this.parentCategoryLevel = level
    this.parantObj = { ...categoryObj }
  }
  resetData () {
    this.form.categoryId = ''
    this.form.categoryName = ''
  }
  handleCancel () {
    this.visible = false
  }
  validateForm () {
    return new Promise(resolve => {
      (this.$refs.form as Form).validate().then(() => {
        resolve(true)
      })
    })
  }
  async onSubmit () {
    await this.validateForm()
    let params = {
      parentName: this.parantObj.categoryName,
      categoryLevel: parseInt(this.parantObj.categoryLevel || '0') + 1,
      categoryName: this.form.categoryName,
      parentId: this.parantObj.categoryId,
      parentHierarchyId: this.parantObj.hierarchyId
    }
    addGoodsCategory(params).then(res => {
      this.$toast('新增成功')
      this.visible = false
      this.$emit('load')
    })
  }
}
